var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('zj-layout-container',[_c('zj-layout-header',[_c('EventTimeLine')],1),_c('zj-layout-main',[_c('EventInfo',{attrs:{"IsEdit":_vm.IsEdit,"EventConfirm":_vm.EventConfirm,"IsAdd":_vm.IsAdd,"EventReport":_vm.EventReport}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }